import React from "react";
import styles from "./GeoZoneReport.module.css";

export type ReportRow = {
    geoZone: string;
    date: string;
    status: string;
    reason: string;
    contractor: string;
    vehicleNumber: string;
    collectionMethod: string;
};

type GeoZoneReportProps = {
    data: ReportRow[];
};

const columns = [
    "Геозона / Адрес",
    "Дата вывоза",
    "Подрядчик / организация",
    "Номер машины",
    "Способ сбора",
];

const GeoZoneReportTable = ({ data }: GeoZoneReportProps) => {
    return (
        <div className={styles.tableWrapper}>
            <div className={styles.table}>
                <div className={styles.header}>
                    {columns.map((col) => (
                        <div key={col} className={styles.th}>
                            {col}
                        </div>
                    ))}
                </div>
                <div className={styles.body}>
                    {data.length > 0 ? (
                        data.map((row, i) => (
                            <div key={i} className={styles.tr}>
                                <div className={styles.td}>{row.geoZone}</div>
                                <div className={styles.td}>{row.date}</div>
                                <div className={styles.td}>{row.status}</div>
                                <div className={styles.td}>{row.reason || "—"}</div>
                                <div className={styles.td}>{row.contractor}</div>
                                <div className={styles.td}>{row.vehicleNumber}</div>
                                <div className={styles.td}>{row.collectionMethod}</div>
                            </div>
                        ))
                    ) : (
                        <div className={styles.empty}>Нет данных</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GeoZoneReportTable;
